import script from "./NavigationContent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationContent.vue?vue&type=script&setup=true&lang=js"

import "./NavigationContent.vue?vue&type=style&index=0&id=5f03bc58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f03bc58"]])

export default __exports__